import React from 'react';
import { Box, CheckBox, costFormater, List } from '@common-fe/common-fe';

import { UnpaidInvoice } from '../../UnappliedFunds.types';

interface Props extends UnpaidInvoice {
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: (id: string, checked: boolean) => void;
}

const UnpaidInvoiceItem: React.FC<Props> = ({ id, type, date, amount, isSelected, isDisabled, onToggle }) => {
  const textColor = isDisabled ? 'textDisabled' : undefined;
  const background = isSelected ? 'accentContainer' : isDisabled ? 'module' : 'canvas';
  const borderColor = isSelected ? 'accentActive' : isDisabled ? 'border1' : 'border2';

  return (
    <List.Item
      testId={`unpaid-invoices_item_${id}`}
      disableHover
      background={background}
      border={{ size: 'small', color: borderColor }}
      height={{ min: '68px' }}
    >
      <Box direction="row" align="center" gap="spacing24" fill>
        <Box width="24px" align="start">
          <CheckBox
            name="unpaidInvoice"
            role="checkbox"
            aria-label={`unpaidInvoice-${id}`}
            data-testid={`unpaid-invoices_item_${id}_checkbox`}
            checked={isSelected}
            disabled={isDisabled}
            onChange={({ target }) => onToggle(id, target.checked)}
          />
        </Box>
        <Box width="240px">
          <List.Item.Text testId={`unpaid-invoices_item_${id}_number`} weight="bold" color={textColor}>
            {id}
          </List.Item.Text>
        </Box>
        <Box width="160px">
          <List.Item.Text testId={`unpaid-invoices_item_${id}_type`} weight={400} color={textColor}>
            {type}
          </List.Item.Text>
        </Box>
        <Box width="110px">
          <List.Item.Text testId={`unpaid-invoices_item_${id}_date`} weight={400} color={textColor}>
            {date}
          </List.Item.Text>
        </Box>
        <Box flex>
          <List.Item.Text
            testId={`unpaid-invoices_item_${id}_amount`}
            weight="bold"
            textAlign="end"
            color={textColor}
          >
            {costFormater(amount, true)}
          </List.Item.Text>
        </Box>
      </Box>
    </List.Item>
  );
};

export default UnpaidInvoiceItem;
